{"id":"Center","tags":["layout"],"prefabs":{"default":{"children":[{"component":"Center","options":"options:*"}]}}}